module.exports = __webpack_public_path__ + "img/streak70.6582756a.png";